/** Canonical default rates for each named tax type (as a decimal fraction). */
export const TAX_TYPE_DEFAULTS = {
    GST: 0.1,
    VAT: 0.2,
    HST: 0.13,
    PST: 0.07,
    SALES_TAX: 0,
    NONE: 0,
    CUSTOM: 0,
};
/** Human-readable label for each tax type. */
export const TAX_TYPE_LABELS = {
    GST: 'GST',
    VAT: 'VAT',
    HST: 'HST',
    PST: 'PST',
    SALES_TAX: 'Sales Tax',
    NONE: 'No Tax',
    CUSTOM: 'Custom',
};
//# sourceMappingURL=tax.js.map